/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One admission as read from MatrixCare.
 * @export
 * @interface MatrixCareLiveAdmission
 */
export interface MatrixCareLiveAdmission {
    /**
     * MatrixCare `AdmissionId`.
     */
    admission_id: string;
    /**
     * MatrixCare's numeric admission key.
     */
    admission_key?: number | null;
    /**
     * 
     */
    referral_id?: string | null;
    /**
     * e.g. "New Referral", "Discharge Pending", "Admitted".
     */
    status?: string | null;
    /**
     * 
     */
    status_code?: number | null;
    /**
     * 
     */
    status_id?: string | null;
    /**
     * ISO YYYY-MM-DD.
     */
    effective_date?: string | null;
    /**
     * 
     */
    business_unit_id?: string | null;
    /**
     * Resolved from the business unit lookup.
     */
    business_unit_name?: string | null;
    /**
     * 
     */
    line_of_business_id?: string | null;
    /**
     * e.g. "Skilled OASIS", "Skilled Non OASIS".
     */
    line_of_business_name?: string | null;
    /**
     * 
     */
    line_of_business_type?: string | null;
    /**
     * 
     */
    certification_period_start?: string | null;
    /**
     * 
     */
    is_new_referral: boolean;
    /**
     * 
     */
    is_hospice_patient: boolean;
    /**
     * 
     */
    is_resumed: boolean;
}

/**
 * Check if a given object implements the MatrixCareLiveAdmission interface.
 */
export function instanceOfMatrixCareLiveAdmission(value: object): value is MatrixCareLiveAdmission {
    if (!('admission_id' in value) || value['admission_id'] === undefined) return false;
    if (!('is_new_referral' in value) || value['is_new_referral'] === undefined) return false;
    if (!('is_hospice_patient' in value) || value['is_hospice_patient'] === undefined) return false;
    if (!('is_resumed' in value) || value['is_resumed'] === undefined) return false;
    return true;
}

export function MatrixCareLiveAdmissionFromJSON(json: any): MatrixCareLiveAdmission {
    return MatrixCareLiveAdmissionFromJSONTyped(json, false);
}

export function MatrixCareLiveAdmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareLiveAdmission {
    if (json == null) {
        return json;
    }
    return {
        
        'admission_id': json['admission_id'],
        'admission_key': json['admission_key'] === undefined ? undefined : json['admission_key'] === null ? null : json['admission_key'],
        'referral_id': json['referral_id'] === undefined ? undefined : json['referral_id'] === null ? null : json['referral_id'],
        'status': json['status'] === undefined ? undefined : json['status'] === null ? null : json['status'],
        'status_code': json['status_code'] === undefined ? undefined : json['status_code'] === null ? null : json['status_code'],
        'status_id': json['status_id'] === undefined ? undefined : json['status_id'] === null ? null : json['status_id'],
        'effective_date': json['effective_date'] === undefined ? undefined : json['effective_date'] === null ? null : json['effective_date'],
        'business_unit_id': json['business_unit_id'] === undefined ? undefined : json['business_unit_id'] === null ? null : json['business_unit_id'],
        'business_unit_name': json['business_unit_name'] === undefined ? undefined : json['business_unit_name'] === null ? null : json['business_unit_name'],
        'line_of_business_id': json['line_of_business_id'] === undefined ? undefined : json['line_of_business_id'] === null ? null : json['line_of_business_id'],
        'line_of_business_name': json['line_of_business_name'] === undefined ? undefined : json['line_of_business_name'] === null ? null : json['line_of_business_name'],
        'line_of_business_type': json['line_of_business_type'] === undefined ? undefined : json['line_of_business_type'] === null ? null : json['line_of_business_type'],
        'certification_period_start': json['certification_period_start'] === undefined ? undefined : json['certification_period_start'] === null ? null : json['certification_period_start'],
        'is_new_referral': json['is_new_referral'],
        'is_hospice_patient': json['is_hospice_patient'],
        'is_resumed': json['is_resumed'],
    };
}

export function MatrixCareLiveAdmissionToJSON(json: any): MatrixCareLiveAdmission {
    return MatrixCareLiveAdmissionToJSONTyped(json, false);
}

export function MatrixCareLiveAdmissionToJSONTyped(value?: MatrixCareLiveAdmission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'admission_id': value['admission_id'],
        'admission_key': value['admission_key'],
        'referral_id': value['referral_id'],
        'status': value['status'],
        'status_code': value['status_code'],
        'status_id': value['status_id'],
        'effective_date': value['effective_date'],
        'business_unit_id': value['business_unit_id'],
        'business_unit_name': value['business_unit_name'],
        'line_of_business_id': value['line_of_business_id'],
        'line_of_business_name': value['line_of_business_name'],
        'line_of_business_type': value['line_of_business_type'],
        'certification_period_start': value['certification_period_start'],
        'is_new_referral': value['is_new_referral'],
        'is_hospice_patient': value['is_hospice_patient'],
        'is_resumed': value['is_resumed'],
    };
}

